import FilterableForm from "../common/filterableForm";

interface CustomerFilterProps {
  filterData?: any;
  setFilterData?: any;
  onClose: () => void;
}

function CustomerFilter({ filterData, setFilterData, onClose }: CustomerFilterProps) {  

  return (
    
    <FilterableForm
      title="Customer Filters"
      fields={[
          { name: "id", label: "ID", type: "number", defaultValue: "" },
          { name: "username", label: "Username", type: "text", defaultValue: '' },
          { name: "email", label: "Email", type: "text", defaultValue: '' },
      ]}

      onClose={onClose}
    />



  );
}

export default CustomerFilter;
